import type { VideoPlayedData } from "@/types/ga4";

type VideoProgress = Pick<
  VideoPlayedData,
  "video_duration" | "video_current_time" | "video_percent"
>;

const toSeconds = (value: number | undefined) =>
  value !== undefined && Number.isFinite(value) ? Math.round(value) : 0;

/** GA4 "Video Played" progress fields, read straight from the element (0 before metadata loads). */
export const getVideoProgress = (video: HTMLVideoElement | null | undefined): VideoProgress => {
  const video_duration = toSeconds(video?.duration);
  const video_current_time = toSeconds(video?.currentTime);
  return {
    video_duration,
    video_current_time,
    video_percent: video_duration > 0 ? Math.round((video_current_time / video_duration) * 100) : 0,
  };
};
